export default __webpack_public_path__ + "static/media/validateimg.6cfb3ceb.png";